<template>
    <div>
        <message-component id="message" v-model="isMessage">{{ message }}</message-component>
        <form @submit.prevent>
            <v-row justify="center">
                <v-col cols="12" xl="2">
                    <label-component fontWeight="bold" style="margin-top: 30px; margin-bottom:100px; font-size:3.5rem !important;">ログイン</label-component>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" xl="2" lg="2" md="2" sm="2">
                    <label-component>メールアドレス</label-component>
                </v-col>
                <v-col cols="12" xl="3" lg="3" md="3" sm="3">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                        <v-text-field outlined clearable v-disabled-icon-focus v-model="email" :error-messages="errors" background-color="white"></v-text-field>
                    </ValidationProvider>
                </v-col>
                <v-col cols="12" xl="2" lg="2" md="2" sm="2">
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" xl="2" lg="2" md="2" sm="2">
                    <label-component>パスワード</label-component>
                </v-col>
                <v-col cols="12" xl="3" lg="3" md="3" sm="3">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                        <v-text-field outlined clearable v-disabled-icon-focus v-model="password" type='password' :error-messages="errors" background-color="white"></v-text-field>
                    </ValidationProvider>
                </v-col>
                <v-col cols="12" xl="2" lg="2" md="2" sm="2">
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" xl="2" lg="2" md="2" sm="2">
                    <button-component block @click="login" :disabled="disabled">ログイン</button-component>
                </v-col>
            </v-row>
        </form>
        <v-row justify="center">
            <v-col cols="auto" class="passwork_reset_area">
                パスワードを忘れた方は<a href="/documents/password_reset" class="password_reset_link">こちら</a>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                email: null,
                password: null,
                disabled: false,
                // メッセージ
                message: null,
                success: false,
            }
        },
        computed: {
            isMessage: {
                get() {
                    return this.message != null;
                },
                set(value) {
                    if (!value) {
                        this.message = null;
                    }
                }
            },
        },
        methods: {
            login: async function (event) {
                this.disabled = true;
                var response = await window.axios.post(
                    '/documents/login',
                    {
                        'email': this.email,
                        'password': this.password,
                    }
                )
                .then(res => {
                    this.success = res.data.success;
                    this.message = res.data.message;
                    if (this.success) {
                        if ('redirect' in res.data && res.data.redirect != null) {
                            
                            if(res.data.redirect.hasOwnProperty('intended')){
                                window.location = res.data.redirect.intended;
                            }else{
                                window.location = "/documents/" + res.data.redirect;
                            }
                            
                        } else {
                            window.location = "/documents/dashboard";
                        }
                    } else {
                        this.disabled = false;
                    }
                }).catch(res => {
                    this.success = false;
                    if (res.response != null && res.response.status == 419) {
                        this.message = "認証チェックエラーが発生しました\n画面の再読み込みを行ってください";
                    } else {
                        this.message = "処理に失敗しました";
                    }
                }).finally(() => {
                    this.disabled = false;
                });
            }
        },
    }
</script>
<style scoped>
    .passwork_reset_area {
        text-align: right;
        font-size: 20px;
    }
    .password_reset_link a:hover {
        text-decoration-line: underline;
    }
</style>
